// Types
// ========================================================
export type { RenderIconOpts } from './types';

// Functionality
// ========================================================
export {
    randSeed,
    seedRand,
    rand,
    createColor,
    createImageData,
    buildOpts,
    renderSVGIcon,
    renderDataURI
} from './actions';